import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { updateMedicalForm } from '../../../../redux/modules/medicalClaim';
import AccidentInfoStep from '../../../CompensationContainer/Steps/AccidentInfoStep';
import accidentInfoSchema from '../../../../validations/claimValidationSchema/accidentInfoSchema';
import { ACCIDENT_INFO_FIELDS } from './options';

const MedicalAccidentInfoStep = ({
  step,
  goNext,
  goPrevious,
  params: { setStepNavigationBox },
}) => {
  const medicalClaim = useSelector(
    (store) => store.medicalClaim,
    shallowEqual,
  );

  return (
    <AccidentInfoStep
      claim={medicalClaim}
      formLanguage={medicalClaim.language}
      setStepNavigationBox={setStepNavigationBox}
      step={step}
      goNext={goNext}
      goPrevious={goPrevious}
      validationSchema={accidentInfoSchema}
      requiredFields={ACCIDENT_INFO_FIELDS}
      updateForm={updateMedicalForm}
    />
  );
};

MedicalAccidentInfoStep.propTypes = {
  initialData: PropTypes.shape({
    accidentDate: PropTypes.instanceOf(Date),
    damageAmount: PropTypes.number,
    contract: PropTypes.shape({}),
    currency: PropTypes.shape({}),
  }),
  step: PropTypes.shape({
    claimForm: PropTypes.string.isRequired,
    n: PropTypes.number.isRequired,
  }).isRequired,
  goNext: PropTypes.func.isRequired,
  goPrevious: PropTypes.func.isRequired,
  params: PropTypes.shape({
    setStepNavigationBox: PropTypes.func.isRequired,
  }).isRequired,
};

MedicalAccidentInfoStep.defaultProps = {
  initialData: null,
};

export default MedicalAccidentInfoStep;
